import { render, staticRenderFns } from "./OrganizationInformation.vue?vue&type=template&id=2c940eed&scoped=true"
import script from "./OrganizationInformation.vue?vue&type=script&lang=js"
export * from "./OrganizationInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c940eed",
  null
  
)

export default component.exports